import cn from '@/lib/clsxm';

import Carousel, { CarouselItem } from '@/components/@base/carousel';
import Container from '@/components/@base/container';
import { Props } from '@/components/app/demo/components/others/props';
import Demo from '@/components/shared/components/cards/demo';

export default function Others({
  data,
  productPrice,
  productIcon,
  productLastPrice,
  show,
  productId,
  productSlug,
}: Props) {
  return (
    <Container
      className={cn(
        'fixed left-0 top-[250px] w-full translate-y-[-850px] overflow-visible overflow-x-clip! bg-[#F9FAFC] p-[30px] py-[80px] transition-transform duration-300',
        show && '-translate-y-[170px]',
      )}
    >
      <Carousel
        className=' overflow-visible!  overflow-x-clip!'
        spaceBetween={20}
        slidesPerView='auto'
      >
        {data?.map((item) => {
          item['price'] = productPrice;
          item['icon'] = productIcon;
          item['lastPrice'] = productLastPrice;
          item['title'] = item?.demoCover?.title;
          item['slug'] = productSlug;
          return (
            <CarouselItem key={item.id} className='w-[304px]! hover:z-40'>
              <Demo data={item} />
            </CarouselItem>
          );
        })}
      </Carousel>
    </Container>
  );
}
